module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "article"
  }, [(_vm.term) ? _c('h1', {
    staticClass: "article-term"
  }, [_vm._v(_vm._s(_vm.article.term_org))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "article-term"
  }, [_vm._v(_vm._s(_vm.term))]), _vm._v(" "), _c('h4', {
    staticClass: "article-title"
  }, [_c('i', [_vm._v(_vm._s(_vm.article.title))])]), _vm._v(" "), (_vm.article.keywords) ? _c('div', {
    staticClass: "article-tags"
  }, _vm._l((_vm.article.keywords), function(tag) {
    return _c('span', [_vm._v(_vm._s(tag.keyword))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.article.links) ? _c('div', {
    staticClass: "article-links"
  }, _vm._l((_vm.article.links), function(link) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": '/article/' + link.id
      }
    }, [_vm._v("\n        " + _vm._s(link.term_english) + "\n      ")])], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.article.img_url) ? _c('img', {
    staticClass: "article-img",
    attrs: {
      "src": 'images/' + _vm.article.img_url
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article-body",
    domProps: {
      "innerHTML": _vm._s(_vm.article.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article-references"
  }, [_c('h3', [_vm._v("BIBLIOGRAPHIC REFERENCES")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.article.references)
    }
  })]), _vm._v(" "), (_vm.showAuthor) ? _c('h4', {
    staticClass: "article-author"
  }, [_c('i', [_vm._v(" " + _vm._s(_vm.article.author_name) + " " + _vm._s(_vm.article.author_surname))]), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.article.author_affiliation))])]) : _vm._e(), _vm._v(" "), (_vm.edition_id) ? _c('p', {
    staticClass: "article-published"
  }, [_vm._v("\n    Published in Series ... , Vol ... (ou special Edition Nr...), 2019\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a77ec32a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Article.vue
// module id = 170
// module chunks = 2